import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { useTimezoneDisplay } from './hooks/use-timezone-display';

export interface TimezoneDisplayProps {
  timezone?: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'light' | 'subdued' | 'primary';
}

/**
 * Reusable timezone display component
 * Consolidates the repeated timezone abbreviation display pattern
 */
export const TimezoneDisplay = ({ timezone, size = 'medium', color = 'light' }: TimezoneDisplayProps) => {
  const { t } = useTranslation('phone');
  const { tzAbbrev } = useTimezoneDisplay(timezone);

  if (!tzAbbrev) {
    return null;
  }

  return (
    <Text size={size} color={color} css={{ alignSelf: 'flex-end' }}>
      {t('All Hours are {{tzAbbrev}}', { tzAbbrev })}
    </Text>
  );
};
